import { createSlice } from '@reduxjs/toolkit';

const loadingSlice = createSlice({
  name: 'loading',
  initialState: {
    global: false,
    page: false,
    table: false,
    loaders: {},
  },
  reducers: {
    startLoading: (state, action) => {
      const key = action.payload || 'global';
      state.loaders[key] = true;
      if (key === 'global') state.global = true;
      if (key === 'page') state.page = true;
      if (key === 'table') state.table = true;
    },
    stopLoading: (state, action) => {
      const key = action.payload || 'global';
      state.loaders[key] = false;
      if (key === 'global') state.global = false;
      if (key === 'page') state.page = false;
      if (key === 'table') state.table = false;
    },
    resetLoading: (state) => {
      state.global = false;
      state.page = false;
      state.table = false;
      state.loaders = {};
    },
  },
});

export const { startLoading, stopLoading, resetLoading } = loadingSlice.actions;
export default loadingSlice.reducer;
